module.exports = __webpack_public_path__ + "img/stock3.46539c31.png";